import React from 'react';
import { useTheme } from 'styled-components';

const TextIcon = ({ size = 14, ...props }) => {
  const theme = useTheme();
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="24"
        height="24"
        rx="4"
        fill={theme?.dark ? '#5C4560' : '#F8F2F7'}
      />
      <path
        d="M6 10H18"
        stroke={theme?.dark ? '#F5E6F2' : '#4A154B'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 13H12.3133"
        stroke={theme?.dark ? '#F5E6F2' : '#4A154B'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TextIcon;
